@if (items?.length > 0 && !isLoading) {
  <ul class="my-circle-list">
    @for (item of items; track item) {
      <li [attr.title]="item.tooltip">
        <mibp-time-ago [date]="item.date"></mibp-time-ago>
        <span class="line"></span>
        <span class="title"><ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: item}"></ng-template></span>
      </li>
    }
  </ul>
}



@if (isLoading) {
  <mibp-loader></mibp-loader>
}

@if (!hasError && items?.length === 0) {
  <div class="my-discreet-error">
    <p><mibp-resource-string key="Global_NoItemsAvailable"></mibp-resource-string></p>
  </div>
}

@if (hasError) {
  <div class="my-discreet-error">
    <p><mibp-resource-string key="Global_Error_DataCouldNotBeLoaded"></mibp-resource-string></p>
    @if (allowRetry) {
      <p><a href="javascript:void(0)" (click)="triggerRetry()"><mibp-resource-string key="Global_Action_TryAgain"></mibp-resource-string></a></p>
    }
  </div>
}
